import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';

import Label from '../../../Components/Label';
import InputField from '../../../Components/InputField';
import SelectBox2 from '../../../Components/Select2';
import Button from '../../../Components/Button';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from "react-select";

import { GlobalContext } from '../../../GlobalContext';

const EditUser = () => {
    const navigate = useNavigate();
    const { currentTab, setCurrentTab } = useContext(GlobalContext);

    useEffect(() => {
        setCurrentTab('Edit users');
    });
    const { staffId } = useParams();

    const token = localStorage.getItem('token');

    const [account, setAccount] = useState('OFF');
    const [voice, setVoice] = useState('OFF');
    const [companyDispatcher, setCompanyDispatcher] = useState('OFF');

    const [companyList, setCompanyList] = useState([]);
    const [staffData, setStaffData] = useState({});
    const [groupNames, setGroupNames] = useState('');
    const [imeivalue, setImeiValue] = useState('');

    useEffect(() => {
        fetchCompany();
        fetchStaff();
    }, []);

    const fetchCompany = async () => {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }

        await axios.post(`${POCBaseUrl}/companys/get`,
            {
                headers: {
                    "Content-Type": "application/json", // Specify content type
                    Authorization: `Bearer ${token}`, // Include the token
                },
            }
        )
            .then(response => {
                setCompanyList(response.data.data);

            })
            .catch(error => {
                console.error("There was an error fetching the customer data!", error);
            });
    }

    const fetchStaff = async () => {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }

        await axios.post(`${POCBaseUrl}/staffs/getone`, {staffId: staffId},
            {
                headers: {
                  "Content-Type": "application/json", // Specify content type
                  Token: token ,  // Include the token
                },
              }
        )
        .then(response => {
            // console.log('response',response.data, response.data.data.name);
            setStaffData(response.data.data);
            const data = response.data.data;
            setSelectedCompany(data.company_id);
            setImeiValue(data.imei);
            const groupnames = data.group_ids.map(group => group.name).join(", ");

            setGroupNames(groupnames);
        })
        .catch(error => {
            console.error("There was an error fetching the customer data!", error);
        });
    }

    const handleStaffChange = (e) => {
        setStaffData({
            ...staffData,
            [e.target.name]: e.target.value,
        });
    };

    
    const [imeiError, setImeiError] = useState('');
    const validateIMEI = (imei) => {
        if (!/^\d{15}$/.test(imei)) {
            return { isValid: false, message: 'IMEI must be exactly 15 digits.' };
        }
    
        let sum = 0;
        for (let i = 0; i < 14; i++) {
            let digit = parseInt(imei[i]);
            if (i % 2 === 0) { // Double digits at even indices (0-based: 0, 2, 4, 6, 8, 10, 12)
                let doubled = digit * 2;
                sum += doubled > 9 ? doubled - 9 : doubled;
            } else {
                sum += digit;
            }
        }
        sum += parseInt(imei[14]);
        // const isValid = sum % 10 === 0;
        const isValid = true;
    
        return {
            isValid,
            message: isValid ? '' : 'Invalid IMEI. Please check the number.',
        };
    };

    const handleImeiChange = (e) => {
        const value = e.target.value;
        setImeiValue(value);
        const { message } = validateIMEI(value);
        setImeiError(message);
    };

    const [selectedCompany, setSelectedCompany] = useState(null);
    const changeCompany = (option) => {
        // //console.log(option,'options');
        setSelectedCompany(option);
        if(option) {
            setStaffData({
                ...staffData,
                ['company_id']: option._id,
            });
            const id = option._id;
            handleCompanyUpdate(id);
        } else {
            setStaffData({
                ...staffData,
                ['company_id']: '',
            });
        }
    };

    const gotoStaffList = () => {
        navigate(`/userlist`); // Use navigate for routing
    };

    //--------------recharge -----------------------------
    const [gpsFunctionCardRechargeOpen, setGPSFunctionCardRecharge] = useState(false);
    const [recordingFunctionCardRechargeOpen, setRecordingFunctionCardRecharge] = useState(false);
    const [sosFunctionCardRechargeOpen, setSOSFunctionCardRecharge] = useState(false);
    const [boundingFunctionCardRechargeOpen, setBoundingFunctionCardRecharge] = useState(false);
    const [duplexFunctionCardRechargeOpen, setDuplexFunctionCardRecharge] = useState(false);
    const [cardButton, setCardButton] = useState('Recording card');
    const handleCardButton = (value) => {
        setCardButton(value);
    }

    const handleReplaceIMEI = async() => {
        if (imeivalue === '') {
            toast.warn("Please input IMEI", {
                className: 'centered-toast-warn',
                bodyClassName: 'centered-body',
                autoClose: 2000,
                hideProgressBar: true,
                closeButton: false,
                pauseOnHover: false,
                draggable: true,
              });
            return;
        }

        if (imeiError) {
            toast.warn("IMEI contains 15 numbers.", {
                className: 'centered-toast-warn',
                bodyClassName: 'centered-body',
                autoClose: 2000,
                hideProgressBar: true,
                closeButton: false,
                pauseOnHover: false,
                draggable: true,
              });
            return;
        }

        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;
        const response = await axios.post(`${POCBaseUrl}/staffs/replaceimei`, {imeivalue: imeivalue, staffId: staffId},
            {
                headers: {
                  "Content-Type": "application/json", // Specify content type
                  Token: token,
                },
              }
        );
        if(response.data.success) {
            fetchStaff();
            toast.success("Updated successfully!", {
                className: 'centered-toast-success',
                bodyClassName: 'centered-body',
                autoClose: 2000,
                hideProgressBar: true,
                closeButton: false,
                pauseOnHover: false,
                draggable: true,
              });
        } else {
            toast.warn("Account already exists!", {
                className: 'centered-toast-warn',
                bodyClassName: 'centered-body',
                autoClose: 2000,
                hideProgressBar: true,
                closeButton: false,
                pauseOnHover: false,
                pauseOnFocusLoss: true
            });
        }
    }

    const handleCompanyUpdate = async (id) => {
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            const companyId = id;
            const response = await axios.post(`${POCBaseUrl}/staffs/companyedit`, {staffId,companyId},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Token: token,
                    },
                  }
            );
            if(response.data.success) {
                toast.success("Updated successfully!", {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
            } else {
                toast.warn("Failed!" , {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    pauseOnFocusLoss: true
                });
            };
        } catch (error) {
            console.error('Error sending message:', error);
        }
    };

    const handleStaffNameUpdate = async() => {
        try {
            const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

            if (!POCBaseUrl) {
                throw new Error('API base URL is not defined');
            }

            if (staffData.nick_name === '') {
                toast.warn("Please input nick name", {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });
                return;
            }

            // if (staffData.imei === '') {
            //     toast.warn("Please input IMEI", {
            //         className: 'centered-toast-warn',
            //         bodyClassName: 'centered-body',
            //         autoClose: 2000,
            //         hideProgressBar: true,
            //         closeButton: false,
            //         pauseOnHover: false,
            //         draggable: true,
            //       });
            //     return;
            // }

            // if (imeiError) {
            //     toast.warn("IMEI contains 15 numbers.", {
            //         className: 'centered-toast-warn',
            //         bodyClassName: 'centered-body',
            //         autoClose: 2000,
            //         hideProgressBar: true,
            //         closeButton: false,
            //         pauseOnHover: false,
            //         draggable: true,
            //       });
            //     return;
            // }

            const response = await axios.post(`${POCBaseUrl}/staffs/edit`, {staffId, staffData},
                {
                    headers: {
                      "Content-Type": "application/json", // Specify content type
                      Token: token,
                    },
                  }
            );
            if(response.data.success) {
                toast.success("Updated successfully!", {
                    className: 'centered-toast-success',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    draggable: true,
                  });

                navigate('/userlist');
            } else {
                toast.warn("Update failed!", {
                    className: 'centered-toast-warn',
                    bodyClassName: 'centered-body',
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: false,
                    pauseOnFocusLoss: true
                });
            }
        } catch (error) {
            console.error('Error sending message:', error);
        }

    };

    return (
        <>
            <div className="flex mt-2.5 bg-[#f0f0f0] rounded-[5px]" style={{ fontFamily: 'Liberation Serif' }}>
                <div className="ml-[25px] mt-2.5 pr-[40px]">
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Company belonged to'} className={'!w-[170px]'} />
                        </div>
                        <div className={ `w-[360px] text-gray-500 bg-[transparent] text-sm tracking-wide flex items-center rounded cursor-pointer hover:!border-[#2776c3] bg-[transparent]`}>
                            <Select
                                name="companylist"
                                placeholder={"Select a company"}
                                className={`basic-multi-select w-full cursor-pointer !m-0 !p-0`}
                                classNamePrefix="select"
                                options={companyList}
                                value={selectedCompany}
                                onChange={changeCompany}
                                getOptionLabel={(option) => option.name} // Show only the label
                                getOptionValue={(option) => option._id}
                                styles={{
                                    control: (provided) => ({
                                    ...provided,
                                    borderColor: '#dcdfe6', // Change border color based on focus state
                                    boxShadow: 'none', // Remove default shadow
                                    '&:hover': {
                                        borderColor: '#2776c3', // Change border color on hover
                                    },
                                    }),
                                }}
                            />
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Please select a company</span>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Belonged group'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <div className='bg-[rgb(248,248,248)] w-[360px] h-[40px]'>
                                <span className='text-[#5a5655] ml-[10px] cursor-pointer'>{groupNames || ''}</span>
                            </div>
                        </div>
                    </div>
                    <div className={`${imeiError ? 'mb-[10px]' : 'mb-[22px]'}  flex`}>
                        <div className='w-[170px]'>
                            <Label text={'IMEI'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative flex text-[14px] leading-[40px]'>
                            <div className={`w-[270px] m-0 p-0`}>
                                <div className="relative flex bg-[white] text-[14px] inline-block w-full border border-[#dcdfe6] rounded">
                                    <input
                                        name = "imei"
                                        value={imeivalue || ''}
                                        pattern="[0-9]*"
                                        type = {'text'}
                                        autoComplete="off"
                                        placeholder={'please enter IMEI'}
                                        className={`w-full bg-white rounded inline-block text-inherit h-[40px] leading-[40px] outline-none px-[15px]`}
                                        onChange={handleImeiChange}
                                    />
                                </div>
                            </div>
                            <div className='ml-2 h-[40px] rounded-md bg-[#2776c3] text-[white] px-5 cursor-pointer hover:bg-[#508fdf]' onClick={() => handleReplaceIMEI()}>replace</div>
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#2776c3] ml-[10px] text-[14px]'>{staffData.imei && staffData.imei || ''}</span>
                    </div>
                    {imeiError && (
                        <div className='mb-[20px]'>
                            <span className="ml-[170px] h-[24px] text-[#fc3b3e] ml-[10px] text-[14px]">
                                {imeiError}
                            </span>
                        </div>
                    )}
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Nickname'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name={'nick_name'} value={staffData.nick_name || ''} onChange={handleStaffChange} placeholder={'Please enter nickname'} />
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Contains 2-11 digits of numbers, letters, characters or underlines, but not starts with underline</span>
                    </div>
                    {/*
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Contact Numbers'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField name={'contact_number'} value={staffData.contact_number || ''} onChange={handleStaffChange} placeholder={'Please contact number'} />
                        </div>
                    </div>
                     <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Account'} />
                        </div>
                        <div className='relative text-[14px] leading-[42px]'>
                            <span onClick={() => setAccount('ON')} className={`${account == 'ON' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} w-[179px] py-3 bg-[#fdfdfd] px-[69px] mr-5 cursor-pointer select-none rounded-md`}>ON</span>
                            <span onClick={() => setAccount('OFF')} className={`${account == 'OFF' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} w-[179px] py-3 bg-[#fdfdfd] px-[69px] mr-5 cursor-pointer select-none rounded-md`}>OFF</span>
                        </div>
                    </div> */}
                    {/* <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Voice'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <span onClick={() => setVoice('ON')} className={`${voice == 'ON' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} w-[179px] py-3 bg-[#fdfdfd] px-[69px] mr-5 cursor-pointer select-none rounded-md`}>ON</span>
                            <span onClick={() => setVoice('OFF')} className={`${voice == 'OFF' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} w-[179px] py-3 bg-[#fdfdfd] px-[69px] mr-5 cursor-pointer select-none rounded-md`}>OFF</span>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Company dispatcher'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <span onClick={() => setCompanyDispatcher('ON')} className={`${companyDispatcher == 'ON' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} w-[179px] py-3 bg-[#fdfdfd] px-[69px] mr-5 cursor-pointer select-none rounded-md`}>ON</span>
                            <span onClick={() => setCompanyDispatcher('OFF')} className={`${companyDispatcher == 'OFF' ? 'border border-[rgb(39,118,195)] !text-[rgb(39,118,195)' : ''} w-[179px] py-3 bg-[#fdfdfd] px-[69px] mr-5 cursor-pointer select-none rounded-md`}>OFF</span>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'GPS sevice'} className={'!w-[170px]'} />
                        <div className='relative text-[14px] leading-[40px] !w-[232px]'>
                            <InputField type={'text'} placeholder={'Not open'} className='!w-[227px]' disabled={true} />
                        </div>
                        <div>
                            <Button children={'Renewal Fee'} onClick={() => {setGPSFunctionCardRecharge(true);handleCardButton('GPS card')}} className={'!bg-[#2776c3] ml-[5px] !w-[120px]'} />
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Recording sevice'} className={'!w-[170px]'} />
                        <div className='relative text-[14px] leading-[40px] !w-[232px]'>
                            <InputField type={'text'} placeholder={'Not open'} className='!w-[227px]' disabled={true} />
                        </div>
                        <div>
                            <Button children={'Renewal Fee'} onClick={() => {setRecordingFunctionCardRecharge(true);handleCardButton('Recording card')}} className={'!bg-[#2776c3] ml-[5px] !w-[120px]'} />
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'SOS sevice'} className={'!w-[170px]'} />
                        <div className='relative text-[14px] leading-[40px] !w-[232px]'>
                            <InputField type={'text'} placeholder={'Not open'} className='!w-[227px]' disabled={true} />
                        </div>
                        <div>
                            <Button children={'ON'} onClick={() => {setSOSFunctionCardRecharge(true);handleCardButton('SOS card')}} className={'!bg-[#2776c3] ml-[5px] !w-[120px]'} />
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Bounding sevice'} className={'!w-[170px]'} />
                        <div className='relative text-[14px] leading-[40px] !w-[232px]'>
                            <InputField type={'text'} placeholder={'Not open'} className='!w-[227px]' disabled={true} />
                        </div>
                        <div>
                            <Button children={'Renewal Fee'} onClick={() => {setBoundingFunctionCardRecharge(true);handleCardButton('Bounding card')}} className={'!bg-[#2776c3] ml-[5px] !w-[120px]'} />
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <Label text={'Duplex sevice'} className={'!w-[170px]'} />
                        <div className='relative text-[14px] leading-[40px] !w-[232px]'>
                            <InputField type={'text'} placeholder={'Not open'} className='!w-[227px]' disabled={true} />
                        </div>
                        <div>
                            <Button children={'Renewal Fee'} onClick={() => {setDuplexFunctionCardRecharge(true);handleCardButton('Duplex card')}} className={'!bg-[#2776c3] ml-[5px] !w-[120px]'} />
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Monitored group'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <div className='bg-[rgb(248,248,248)] w-[360px] h-[40px]'>
                                <span className='text-[#5a5655] ml-[10px] cursor-pointer'>click to view</span>
                            </div>
                        </div>
                    </div> 
                    <div className='mb-[22px] flex'>
                        <Label text={'Account changeable period'} className={'!w-[170px]'} />
                        <div className='relative text-[14px] leading-[40px] !w-[360px]'>
                            <InputField type={'text'} placeholder={staffData.account_changeable_period || ''} className='!w-[360px]' disabled={true} />
                        </div>
                        <div>
                        </div>
                    </div>
                    */}
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'note'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px] w-[360px]'>
                            <textarea
                                placeholder="User notes: within 100 characters"
                                className="p-4 bg-white max-w-md mx-auto w-full block text-sm border border-gray-300 outline-[#007bff] rounded"
                                rows="4"
                                name={'notes'}
                                value={staffData.notes || ''}
                                onChange={handleStaffChange}
                            ></textarea>
                        </div>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Agent note'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px] w-[360px]'>
                            <textarea
                                placeholder="Agent note: whithin 100 characters"
                                className="p-4 bg-white max-w-md mx-auto w-full block text-sm border border-gray-300 outline-[#007bff] rounded"
                                rows="4"
                                name={'agent_notes'}
                                value={staffData.agent_notes || ''}
                                onChange={handleStaffChange}
                            ></textarea>
                        </div>
                    </div>
                    {/* <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'Number of users'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                            <InputField placeholder={'0'} disabled={true} className={'cursor-not-allowed'} />
                        </div>
                        <span className='h-[24px] mt-[10px] text-[#fc3b3e] ml-[10px] text-[14px]'>Max. 1010 users can be created each time</span>
                    </div>
                    <div className='mb-[22px] flex'>
                        <div className='w-[170px]'>
                            <Label text={'created'} className={'!w-[170px]'} />
                        </div>
                        <div className='relative text-[14px] leading-[40px]'>
                        </div>
                    </div> */}
                </div>
            </div>
            <div className='flex mt-2.5 bg-[#f0f0f0]' style={{ fontFamily: 'Liberation Serif' }}>
                <button onClick= {handleStaffNameUpdate} className='inline-block mt-2.5 mb-2.5 ml-44 bg-[#2776c3] py-2 px-16 rounded text-white cursor-pointer'>
                    Update
                </button>
                <button onClick={gotoStaffList} className='inline-block mt-2.5 mb-2.5 ml-3 bg-[#2776c3] py-2 px-16 rounded text-white cursor-pointer'>
                    Return to the list
                </button>
            </div>
            {gpsFunctionCardRechargeOpen && (
                <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]" style={{ fontFamily: 'Liberation Serif' }}>
                    <div className="w-[600px] bg-white shadow-lg rounded-lg p-2 relative">
                        <div className="flex items-center p-5 border-b border-gray-300">
                            <h3 className="text-xl flex-1 text-center text-[#2776c3]">Recharge function card</h3>
                            <svg
                                className="w-3 ml-2 cursor-pointer shrink-0 fill-gray-400 hover:fill-red-500"
                                viewBox="0 0 320.591 320.591"
                                onClick={() => setGPSFunctionCardRecharge(false)} // Close modal on click
                            >
                                <path
                                    d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                                />
                                <path
                                    d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                                />
                            </svg>
                        </div>

                        <div className='flex justify-center'>
                            <div className='mt-[20px] flex flex-col items-center text-center mx-[30px] my-[20px] pr-[30px] border-r border-[#999999]'>
                                <span className='text-center text-[#5a5655] text-[14px]'>GPS card</span>
                                <span className='text-center text-[#5a5655] text-[14px]'>{staffData.gps_card || 0} Pieces</span>
                            </div>
                        </div>
                        <div className='text-[14px]'>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[140px] text-[#5a5655] text-[14px] text-right'>IMEI:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        disabled
                                        autoComplete="off"
                                        placeholder={staffData.imei || ''}
                                        className="p-0 pl-[15px] w-[300px] h-[40px] text-[#606266] bg-[#f5f7fa] border border-[#e4e7ed] rounded-sm"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[140px] text-[#5a5655] text-[14px] text-right'>Function cards consumed:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="number"
                                        autoComplete="off"
                                        placeholder=""
                                        className="p-0 pl-[15px] w-[300px] h-[40px] text-[#606266] bg-[#fff] border border-[#e4e7ed] rounded-sm outline-none"
                                    // onChange={handleCardValue}
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[160px] text-[#5a5655] text-[14px] text-right'>Funcion card type:</span>
                                <span onClick={() => handleCardButton('GPS card')} className={`inline-block ${cardButton === 'GPS card' ? 'border border-[#2776c3] !text-[#2776c3]' : 'border border-[#c2c2c2] text-[#c2c2c2]'} bg-[#f1f1f1] p-[10px] px-[20px] ml-[5px] mr-[5px] rounded-[5px] cursor-pointer`}>
                                    GPS card
                                </span>
                            </div>
                        </div>

                        <div className="pt-10 flex justify-center gap-4 mb-3" style={{ fontFamily: 'Liberation Serif' }}>
                            <button
                                type="button"
                                className="w-[400px] h-[36px] rounded-md text-[white] text-sm border-none outline-none tracking-wide bg-[#2776c3]"
                            // onClick={handleDeposite} // Close modal on click
                            >
                                deposite
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {recordingFunctionCardRechargeOpen && (
                <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]" style={{ fontFamily: 'Liberation Serif' }}>
                    <div className="w-[600px] bg-white shadow-lg rounded-lg p-2 relative">
                        <div className="flex items-center p-5 border-b border-gray-300">
                            <h3 className="text-xl flex-1 text-center text-[#2776c3]">Recharge function card</h3>
                            <svg
                                className="w-3 ml-2 cursor-pointer shrink-0 fill-gray-400 hover:fill-red-500"
                                viewBox="0 0 320.591 320.591"
                                onClick={() => setRecordingFunctionCardRecharge(false)} // Close modal on click
                            >
                                <path
                                    d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                                />
                                <path
                                    d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                                />
                            </svg>
                        </div>

                        <div className='flex justify-center'>
                            <div className='mt-[20px] flex flex-col items-center text-center my-[20px] pr-[30px] border-r border-[#999999]'>
                                <span className='text-center text-[#5a5655] text-[14px]'>Recording card</span>
                                <span className='text-center text-[#5a5655] text-[14px]'>{staffData.recording_card || 0} Pieces</span>
                            </div>
                        </div>
                        <div className='text-[14px]'>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[140px] text-[#5a5655] text-[14px] text-right'>IMEI:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        disabled
                                        autoComplete="off"
                                        placeholder={staffData.imei || ''}
                                        className="p-0 pl-[15px] w-[300px] h-[40px] text-[#606266] bg-[#f5f7fa] border border-[#e4e7ed] rounded-sm"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[140px] text-[#5a5655] text-[14px] text-right'>Function cards consumed:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="number"
                                        autoComplete="off"
                                        placeholder=""
                                        className="p-0 pl-[15px] w-[300px] h-[40px] text-[#606266] bg-[#fff] border border-[#e4e7ed] rounded-sm outline-none"
                                    // onChange={handleCardValue}
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[160px] text-[#5a5655] text-[14px] text-right'>Funcion card type:</span>
                                <span onClick={() => handleCardButton('Recording card')} className={`inline-block ${cardButton === 'Recording card' ? 'border border-[#2776c3] !text-[#2776c3]' : 'border border-[#c2c2c2] text-[#c2c2c2]'} bg-[#f1f1f1] p-[10px] px-[20px] ml-[5px] mr-[5px] rounded-[5px] cursor-pointer`}>
                                    Recording card
                                </span>
                            </div>
                        </div>

                        <div className="pt-10 flex justify-center gap-4 mb-3" style={{ fontFamily: 'Liberation Serif' }}>
                            <button
                                type="button"
                                className="w-[400px] h-[36px] rounded-md text-[white] text-sm border-none outline-none tracking-wide bg-[#2776c3]"
                            // onClick={handleDeposite} // Close modal on click
                            >
                                deposite
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {sosFunctionCardRechargeOpen && (
                <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]" style={{ fontFamily: 'Liberation Serif' }}>
                    <div className="w-[600px] bg-white shadow-lg rounded-lg p-2 relative">
                        <div className="flex items-center p-5 border-b border-gray-300">
                            <h3 className="text-xl flex-1 text-center text-[#2776c3]">Recharge function card</h3>
                            <svg
                                className="w-3 ml-2 cursor-pointer shrink-0 fill-gray-400 hover:fill-red-500"
                                viewBox="0 0 320.591 320.591"
                                onClick={() => setSOSFunctionCardRecharge(false)} // Close modal on click
                            >
                                <path
                                    d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                                />
                                <path
                                    d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                                />
                            </svg>
                        </div>

                        <div className='flex justify-center'>
                            <div className='mt-[20px] flex flex-col items-center text-center my-[20px] pr-[30px] border-r border-[#999999]'>
                                <span className='text-center text-[#5a5655] text-[14px]'>SOS card</span>
                                <span className='text-center text-[#5a5655] text-[14px]'>{staffData.sos_card || 0} Pieces</span>
                            </div>
                        </div>
                        <div className='text-[14px]'>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[140px] text-[#5a5655] text-[14px] text-right'>IMEI:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        disabled
                                        autoComplete="off"
                                        placeholder={staffData.imei || ''}
                                        className="p-0 pl-[15px] w-[300px] h-[40px] text-[#606266] bg-[#f5f7fa] border border-[#e4e7ed] rounded-sm"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[140px] text-[#5a5655] text-[14px] text-right'>Function cards consumed:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="number"
                                        autoComplete="off"
                                        placeholder=""
                                        className="p-0 pl-[15px] w-[300px] h-[40px] text-[#606266] bg-[#fff] border border-[#e4e7ed] rounded-sm outline-none"
                                    // onChange={handleCardValue}
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[160px] text-[#5a5655] text-[14px] text-right'>Funcion card type:</span>
                                <span onClick={() => handleCardButton('SOS card')} className={`inline-block ${cardButton === 'SOS card' ? 'border border-[#2776c3] !text-[#2776c3]' : 'border border-[#c2c2c2] text-[#c2c2c2]'} bg-[#f1f1f1] p-[10px] px-[20px] ml-[5px] mr-[5px] rounded-[5px] cursor-pointer`}>
                                    SOS card
                                </span>
                            </div>
                        </div>

                        <div className="pt-10 flex justify-center gap-4 mb-3" style={{ fontFamily: 'Liberation Serif' }}>
                            <button
                                type="button"
                                className="w-[400px] h-[36px] rounded-md text-[white] text-sm border-none outline-none tracking-wide bg-[#2776c3]"
                            // onClick={handleDeposite} // Close modal on click
                            >
                                deposite
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {boundingFunctionCardRechargeOpen && (
                <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]" style={{ fontFamily: 'Liberation Serif' }}>
                    <div className="w-[600px] bg-white shadow-lg rounded-lg p-2 relative">
                        <div className="flex items-center p-5 border-b border-gray-300">
                            <h3 className="text-xl flex-1 text-center text-[#2776c3]">Bounding function card</h3>
                            <svg
                                className="w-3 ml-2 cursor-pointer shrink-0 fill-gray-400 hover:fill-red-500"
                                viewBox="0 0 320.591 320.591"
                                onClick={() => setBoundingFunctionCardRecharge(false)} // Close modal on click
                            >
                                <path
                                    d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                                />
                                <path
                                    d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                                />
                            </svg>
                        </div>

                        <div className='flex justify-center'>
                            <div className='mt-[20px] flex flex-col items-center text-center mx-[30px] my-[20px] pr-[30px] border-r border-[#999999]'>
                                <span className='text-center text-[#5a5655] text-[14px]'>Bounding card</span>
                                <span className='text-center text-[#5a5655] text-[14px]'>{staffData.bounding_card || 0} Pieces</span>
                            </div>
                        </div>
                        <div className='text-[14px]'>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[140px] text-[#5a5655] text-[14px] text-right'>IMEI:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        disabled
                                        autoComplete="off"
                                        placeholder={staffData.imei || ''}
                                        className="p-0 pl-[15px] w-[300px] h-[40px] text-[#606266] bg-[#f5f7fa] border border-[#e4e7ed] rounded-sm"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[140px] text-[#5a5655] text-[14px] text-right'>Function cards consumed:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="number"
                                        autoComplete="off"
                                        placeholder=""
                                        className="p-0 pl-[15px] w-[300px] h-[40px] text-[#606266] bg-[#fff] border border-[#e4e7ed] rounded-sm outline-none"
                                    // onChange={handleCardValue}
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[160px] text-[#5a5655] text-[14px] text-right'>Funcion card type:</span>
                                <span onClick={() => handleCardButton('Bounding card')} className={`inline-block ${cardButton === 'Bounding card' ? 'border border-[#2776c3] !text-[#2776c3]' : 'border border-[#c2c2c2] text-[#c2c2c2]'} bg-[#f1f1f1] p-[10px] px-[20px] ml-[5px] mr-[5px] rounded-[5px] cursor-pointer`}>
                                    Bounding card
                                </span>
                            </div>
                        </div>

                        <div className="pt-10 flex justify-center gap-4 mb-3" style={{ fontFamily: 'Liberation Serif' }}>
                            <button
                                type="button"
                                className="w-[400px] h-[36px] rounded-md text-[white] text-sm border-none outline-none tracking-wide bg-[#2776c3]"
                            // onClick={handleDeposite} // Close modal on click
                            >
                                deposite
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {duplexFunctionCardRechargeOpen && (
                <div className="fixed inset-0 p-2 flex flex-wrap justify-center items-center w-full h-full z-[1000] before:fixed before:inset-0 before:w-full before:h-full before:bg-[rgba(0,0,0,0.5)] overflow-auto font-[sans-serif]" style={{ fontFamily: 'Liberation Serif' }}>
                    <div className="w-[600px] bg-white shadow-lg rounded-lg p-2 relative">
                        <div className="flex items-center p-5 border-b border-gray-300">
                            <h3 className="text-xl flex-1 text-center text-[#2776c3]">Recharge function card</h3>
                            <svg
                                className="w-3 ml-2 cursor-pointer shrink-0 fill-gray-400 hover:fill-red-500"
                                viewBox="0 0 320.591 320.591"
                                onClick={() => setDuplexFunctionCardRecharge(false)} // Close modal on click
                            >
                                <path
                                    d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z"
                                />
                                <path
                                    d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z"
                                />
                            </svg>
                        </div>

                        <div className='flex justify-center'>
                            <div className='mt-[20px] flex flex-col items-center text-center my-[20px] pr-[30px] border-r border-[#999999]'>
                                <span className='text-center text-[#5a5655] text-[14px]'>Duplex card</span>
                                <span className='text-center text-[#5a5655] text-[14px]'>{staffData.duplex_card || 0} Pieces</span>
                            </div>
                        </div>
                        <div className='text-[14px]'>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[140px] text-[#5a5655] text-[14px] text-right'>IMEI:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="text"
                                        disabled
                                        autoComplete="off"
                                        placeholder={staffData.imei || ''}
                                        className="p-0 pl-[15px] w-[300px] h-[40px] text-[#606266] bg-[#f5f7fa] border border-[#e4e7ed] rounded-sm"
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[140px] text-[#5a5655] text-[14px] text-right'>Function cards consumed:</span>
                                <div className='flex-1 ml-[5px] relative text-[14px] inline-block w-full'>
                                    <input
                                        type="number"
                                        autoComplete="off"
                                        placeholder=""
                                        className="p-0 pl-[15px] w-[300px] h-[40px] text-[#606266] bg-[#fff] border border-[#e4e7ed] rounded-sm outline-none"
                                    // onChange={handleCardValue}
                                    />
                                </div>
                            </div>
                            <div className='flex flex-row items-center m-[20px]'>
                                <span className='w-[160px] text-[#5a5655] text-[14px] text-right'>Funcion card type:</span>
                                <span onClick={() => handleCardButton('Duplex card')} className={`inline-block ${cardButton === 'Duplex card' ? 'border border-[#2776c3] !text-[#2776c3]' : 'border border-[#c2c2c2] text-[#c2c2c2]'} bg-[#f1f1f1] p-[10px] px-[20px] ml-[5px] mr-[5px] rounded-[5px] cursor-pointer`}>
                                    Duplex card
                                </span>
                            </div>
                        </div>

                        <div className="pt-10 flex justify-center gap-4 mb-3" style={{ fontFamily: 'Liberation Serif' }}>
                            <button
                                type="button"
                                className="w-[400px] h-[36px] rounded-md text-[white] text-sm border-none outline-none tracking-wide bg-[#2776c3]"
                            // onClick={handleDeposite} // Close modal on click
                            >
                                deposite
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default EditUser;